export const issueExchangeStatus = {
  inProgress: 'in_progress',
  shipped: 'shipped',
  received: 'received',
  accepted: 'accepted',
}

export const issueExchangeStatusOptions = [
  {
    label: 'Cuando el cliente solicita el cambio (Estado En proceso)',
    value: issueExchangeStatus.inProgress,
  },
  {
    label: 'Cuando los productos hayan sido enviados por el cliente (Estado Enviado)',
    value: issueExchangeStatus.shipped,
  },
  {
    label: 'Cuando los productos hayan sido recibidos en mi almacén (Estado Recibido)',
    value: issueExchangeStatus.received,
  },
  {
    label: 'Al aceptar los productos devueltos (Estado Aceptado)',
    value: issueExchangeStatus.accepted,
  },
]
